
function mobileTabs(selector, item) {

    const NAVS = Array.from(document.querySelectorAll(selector))

    if(!NAVS.length) return

    NAVS.forEach((nav) => {

        const TRIGGER = nav.querySelector('.trigger')
        const CURRENT = TRIGGER.querySelector('span')
        const ITEMS = Array.from(nav.querySelectorAll(item))

        TRIGGER.addEventListener('click', () => {
            nav.classList.toggle('active')
        })

        ITEMS.forEach(item => {
            item.addEventListener('click', () => {
                nav.classList.remove('active')
                CURRENT.innerText = item.innerText
            })
        })
    })
}

mobileTabs('.nutrition-tabs--navigation-mobile', '.nutrition-tabs--navigation button')
